var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var updateNewsQouteStream = function (data, stream) {
    var news = data.map(function (z) {
        var _a, _b;
        if (((_a = z.customElements) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            var content = (_b = z.customElements) === null || _b === void 0 ? void 0 : _b.map(function (y) {
                if ((y === null || y === void 0 ? void 0 : y.sym) === stream.symbol) {
                    return __assign(__assign({}, y), { chgP: stream.changePercentage });
                }
                else {
                    return y;
                }
            });
            return __assign(__assign({}, z), { customElements: content });
        }
        else {
            return z;
        }
    });
    return news;
};
